import clsx from 'clsx';
import Structure from 'components/corporatiu/Structure';
import styles from './estructura.module.scss';

export default function Estructura(props) {
    const { tag, id, estil } = props;
    const TagHtml = tag;
    const styleEstructura = clsx(estil && styles[estil]);
    return (
        <TagHtml id={id} className={styleEstructura}>
            <Structure {...props} />
        </TagHtml>
    );
}
